/**
 * @author    Wolfgang Kowarschick <kowa@hs-augsburg.de>
 * @copyright 2017
 * @license   CC-BY-NC-SA-4.0
 */

import { evens, odds, pairs } from './sub';
import * as init from 'json!init/init.json';

let name = "Anna";
console.log(evens);
console.log(odds);
console.log(pairs);
console.log(`Hallo, ${name}!`);
console.log(init.test);
